import { Component, OnInit, OnDestroy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserProfileService } from '../../services/user-profile.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-impersonate-user',
  templateUrl: './impersonate-user.component.html',
  styleUrls: ['./impersonate-user.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
]
})
export class ImpersonateUserComponent implements OnInit, OnDestroy {
  isAdmin: boolean = false;
  isImpersonating: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly userProfileService: UserProfileService) {}

  ngOnInit(): void {
    // Check if user is actually an admin (regardless of impersonation state)
    this.userProfileService.isActuallyPlatformAdmin()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAdmin => {
        this.isAdmin = isAdmin;
      });

    // Monitor impersonation state
    this.userProfileService.isImpersonatingUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isImpersonating => {
        this.isImpersonating = isImpersonating;
      });
  }

  toggleImpersonation(): void {
    this.userProfileService.toggleImpersonation(!this.isImpersonating);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
